"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _StandardIconWrapper = _interopRequireDefault(require("./StandardIconWrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var ShowIcon =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(ShowIcon, _React$PureComponent);

  function ShowIcon() {
    _classCallCheck(this, ShowIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(ShowIcon).apply(this, arguments));
  }

  _createClass(ShowIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          color = _this$props.color,
          className = _this$props.className,
          props = _objectWithoutProperties(_this$props, ["color", "className"]);
      /* eslint-disable max-len */


      return _react.default.createElement(_StandardIconWrapper.default, _extends({
        className: (0, _classnames.default)(className, 'show-icon')
      }, props), _react.default.createElement("path", {
        fill: color,
        d: "M6,2.00509001 C8.92109335,1.87409418 11.0077359,4.30501676 11.8174317,5.43698071 C12.0608561,5.77696989 12.0608561,6.22295568 11.8174317,6.56194489 C11.0077359,7.6949088 8.92109335,10.1268314 6,9.99483556 C3.07993811,10.1268314 0.992264054,7.6949088 0.182568334,6.56194489 C-0.0608561114,6.22295568 -0.0608561114,5.77696989 0.182568334,5.43698071 C0.992264054,4.30501676 3.07993811,1.87409418 6,2.00509001 Z M6,3.12505434 C4.36513667,3.12505434 3.03455389,4.41501326 3.03455389,5.99996278 C3.03455389,7.58491231 4.36513667,8.87487123 6,8.87487123 C7.63486333,8.87487123 8.96544611,7.58491231 8.96544611,5.99996278 C8.96544611,4.41501326 7.63486333,3.12505434 6,3.12505434 Z M6,4.25001851 C6.99535843,4.25001851 7.80505415,5.03499351 7.80505415,5.99996278 C7.80505415,6.96493205 6.99535843,7.74990705 6,7.74990705 C5.00464157,7.74990705 4.19494585,6.96493205 4.19494585,5.99996278 C4.19494585,5.03499351 5.00464157,4.25001851 6,4.25001851 Z"
      }));
      /* eslint-enable max-len */
    }
  }]);

  return ShowIcon;
}(_react.default.PureComponent);

exports.default = ShowIcon;
ShowIcon.defaultProps = {
  color: 'inherit'
};
ShowIcon.propTypes = {
  className: _propTypes.default.string,
  color: _propTypes.default.string
};